import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ChangeDetectorRef,
} from "@angular/core";
import { EventNotificationService } from "../../../data-access-layer/notification/event-notification.service";
import { EventNotificationSettings } from "../../../model/notifications/event-notification-settings";
import {
    FormControl,
    FormGroup,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from "@angular/forms";
import { Dataset } from "../../../model/dataset/dataset";
import { DatasetField } from "../../../model/dataset/field/dataset-field";
import { DatapointsFilterService } from "../../datapoints/datapoints-filter.service";
import { FilterBarItem } from "../../../model/datapoint/draft/table/filter-bar-item";
import { DatasetFieldType } from "../../../model/dataset/dataset-field-type";
import { DistanceUnit } from "../../../constants";
import { NotifService } from "../../../core/notification/notif.service";
import { DatasetService } from "../../../data-access-layer/dataset/dataset.service";
import { DatapointFilterField } from "../../../model/datapoint/filter/datapoint-filter-field";
import { Observable } from "rxjs";
import { map, startWith, take } from "rxjs/operators";
import { GroupService } from "../../../data-access-layer/groups/group.service";
import { C, COMMA, ENTER, I } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { AuthService } from "../../../auth/auth.service";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { DialogComponent } from "src/app/shared/dialog/dialog.component";
import { DialogModel } from "src/app/model/dialog/dialog-model";
import { MatDialog } from "@angular/material/dialog";
import { Group } from "src/app/model/group/group";
import { LayerExposeField } from "src/app/account/layer-exposed/services/layer-expose-field";
import { WorkspaceItem } from "src/app/model/workspace/workspace-item";
import { WorkspaceItemType } from "src/app/model/workspace/workspace-item-type";
import { WorkspaceItemAccess } from "src/app/model/workspace/workspace-item-access";
import { WorkspaceItemService } from "../../../data-access-layer/workspace-item/workspace-item.service";
import { MatSelect } from "@angular/material/select";
import { decodeHtmlText } from "../../../core/utils/util-master";
const LIMIT_NUMBER_LENGTH = 16;
const LIMIT_STRING_LENGTH = 50;
const MAX_NUMBER_VALUE = 1.7976931348623157e308;
const MAX_EMAILS = 700;
interface LayerExposeFieldWithSelection extends LayerExposeField {
    selected?: boolean;
}
@Component({
    selector: "map-event-notification",
    templateUrl: "./event-notification.component.html",
    styleUrls: ["./event-notification.component.scss"],
})
export class EventNotificationComponent implements OnInit {
    @Input() eventNotif: EventNotificationSettings;
    @Input() eligibleOverlays: Dataset[];
    @Input() dataset: Dataset;
    @Input() groupsIds: number[];
    @Input() currencies: string[] = [];
    @Input() groups: Group[] = [];
    @Input() layerExposeFields: any[] = [];
    @Input() formulas: WorkspaceItem[] = [];
    @Input() accountMemberEmails: string[] = [];
    @Output() deleteEventNotif = new EventEmitter<EventNotificationSettings>();

    emailControl = new FormControl("", [
        Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}"),
    ]);
    emailsForm = new FormGroup({
        ccEmails: this.emailControl,
    });
    addOnBlur = true;
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    alertsEmails: { email: string; subscribed: boolean }[] = [];
    isDialogOpen = false; // Add flag to track dialog state

    notifForm: UntypedFormGroup;

    filterFieldSearchString: string;
    filterFieldSearchFilter: (field: DatasetField) => boolean;
    filterStatisticValuesString: string;
    filterStatisticValuesFilter: (value: string) => boolean;

    selectedOverlay: Dataset;
    selectedOverlayFilterItems: FilterBarItem[] = [];
    selectedOverlayFilterDisplayedValue: string;

    locationsFilterItems: FilterBarItem[] = [];
    locationsFilterDisplayedValue: string;

    accumulationFilterItems: FilterBarItem[] = [];
    accumulationFilterDisplayedValue: string;
    eligibleAccumulationFields: DatasetField[] = [];

    layerExposeFilterItems: LayerExposeFieldWithSelection[] = [];
    layerExposeFilterDisplayedValue: string = "";
    layerExposeAccumulationFields: LayerExposeFieldWithSelection[] = [];

    // Formula-related properties
    formulaName: string = "";
    selectedFormulaType: string = "";
    // formulas: WorkspaceItem[] = [];

    filteredCurrencies: Observable<string[]>;
    distanceUnit: DistanceUnit = DistanceUnit.KM;
    onSaveFormWithoutFilter: boolean;
    creatorEmail: string;

    breakdownFields: DatasetField[] = [];

    editorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: "8rem",
        minHeight: "3rem",
        placeholder: "Enter text here...",
        translate: "no",
        defaultParagraphSeparator: "p",
        toolbarHiddenButtons: [
            [
                "strikeThrough",
                "subscript",
                "superscript",
                "justifyLeft",
                "justifyCenter",
                "justifyRight",
                "justifyFull",
                "indent",
                "outdent",
                "insertUnorderedList",
                "insertOrderedList",
                "heading",
                "fontName",
                "fontSize",
                "textColor",
                "backgroundColor",
                "removeFormat",
                "insertImage",
                "insertVideo",
                "toggleEditorMode",
            ],
        ],
    };

    allGroups: Group[] = [];
    selectedGroupIds: number[] = [];

    earthquakeMagnitude: number = null;
    earthquakeMagnitudeInvalid: boolean = false;
    magnitudeFieldTouched: boolean = false;

    // Track selected formulas separately
    selectedFormulas: WorkspaceItem[] = [];

    // Keep track of the initial load and retries
    private layerExposeCheckAttempts = 0;
    private maxLayerExposeCheckAttempts = 3;
    private layerExposeInitialDataLoaded = false;

    constructor(
        private readonly eventNotifService: EventNotificationService,
        private readonly formBuilder: UntypedFormBuilder,
        private readonly datapointsFilterService: DatapointsFilterService,
        private readonly notifService: NotifService,
        private readonly groupService: GroupService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly datasetService: DatasetService,
        private readonly authService: AuthService,
        private readonly workspaceItemService: WorkspaceItemService,
        public readonly dialog: MatDialog
    ) {
        this.filterFieldSearchString = "";
        this.filterFieldSearchFilter = (field: DatasetField) => {
            return field.name
                .toLowerCase()
                .includes(this.filterFieldSearchString.toLowerCase());
        };
        this.filterStatisticValuesString = "";
        this.filterStatisticValuesFilter = (value: string) => {
            return value
                .toLowerCase()
                .includes(this.filterStatisticValuesString.toLowerCase());
        };
        this.locationsFilterDisplayedValue = "";
        this.accumulationFilterDisplayedValue = "";
    }

    ngOnInit() {
        this.dataset = JSON.parse(JSON.stringify(this.dataset)); // so that the selected property on the dataset fields doesn't clash with other notifications
        this.breakdownFields = this.dataset.fields.filter(
            (field) =>
                field.baseType === DatasetFieldType.TEXT &&
                !field.isGenerated &&
                !field.tags.includes("ID")
        );

        this.eligibleOverlays = JSON.parse(
            JSON.stringify(this.eligibleOverlays)
        );
        this.eligibleAccumulationFields = JSON.parse(
            JSON.stringify(this.dataset.fields)
        );
        this.eligibleAccumulationFields =
            this.eligibleAccumulationFields.filter(
                (field) =>
                    field.baseType === DatasetFieldType.NUMBER &&
                    !field.isGenerated &&
                    !field.tags.includes("ID")
            );
        this.fetchGroupsForMember();
        this.initNotifForm();
        this.distanceUnit = this.eventNotif.distanceUnit;
        this.filteredCurrencies =
            this.notifForm.controls.currency.valueChanges.pipe(
                startWith(""),
                map((value) => this._filter(value))
            );
        if (
            this.eventNotif.overlayFilter &&
            this.eventNotif.overlayFilter.fields
        ) {
            this.eventNotif.overlayFilter.fields.forEach((field) => {
                if (field.minNumberValue === -1.7976931348623157e308) {
                    field.minNumberValue = null; // Convert to null if the value is -1.7976931348623157e+308
                }
                if (field.maxNumberValue === -1.7976931348623157e308) {
                    field.maxNumberValue = null; // Similarly for maxNumberValue, if needed
                }
            });
        }
        if (
            this.eventNotif.overlayFilter &&
            this.eventNotif.overlayFilter.datasetID
        ) {
            this.datasetService
                .getDataset(this.eventNotif.overlayFilter.datasetID)
                .subscribe((dataset) => {
                    this.selectedOverlay = dataset;
                    this.eventNotif.overlayFilter.fields.forEach(
                        (filterField) => {
                            let datasetField = dataset.fields.find(
                                (field) => field.id === filterField.id
                            );
                            datasetField.selected = true;
                            let filterBarItem =
                                this.constructFilterItemForOverlay(
                                    datasetField,
                                    filterField.textValues
                                );
                            this.populateFilterBarItem(
                                filterBarItem,
                                filterField
                            );
                            this.changeDetector.detectChanges();
                        }
                    );
                    this.selectedOverlayFilterDisplayedValue =
                        this.constructFilterDisplayedValue(
                            this.selectedOverlayFilterItems
                        );
                });
        }
        if (this.eventNotif.locationFilter) {
            this.eventNotif.locationFilter.fields.forEach((filterField) => {
                let datasetField = this.dataset.fields.find(
                    (field) => field.id === filterField.id
                );
                datasetField.selected = true;
                let filterBarItem = this.constructFilterItemForLocations(
                    datasetField,
                    filterField.textValues
                );
                this.populateFilterBarItem(filterBarItem, filterField);
            });
            this.locationsFilterDisplayedValue =
                this.constructFilterDisplayedValue(this.locationsFilterItems);
        }
        if (this.eventNotif.locationsCumulatedFilter) {
            this.eventNotif.locationsCumulatedFilter.fields.forEach(
                (filterField) => {
                    let datasetField = this.eligibleAccumulationFields.find(
                        (field) => field.id === filterField.id
                    );
                    datasetField.selected = true;
                    let filterBarItem = this.constructFilterItemForAccumulation(
                        datasetField,
                        filterField.textValues
                    );
                    this.populateFilterBarItem(filterBarItem, filterField);
                }
            );
            this.accumulationFilterDisplayedValue =
                this.constructFilterDisplayedValue(
                    this.accumulationFilterItems
                );
        }

        if (this.eventNotif.ccEmails) {
            this.alertsEmails = this.eventNotif.ccEmails;
        }

        this.creatorEmail = this.authService.getPrincipal().email;
        if (
            this.alertsEmails.length &&
            !this.alertsEmails
                .map((element) => element.email)
                .includes(this.creatorEmail)
        ) {
            let email = {
                email: this.creatorEmail,
                subscribed: true,
            };
            this.alertsEmails.push(email);
        }

        // Process layer expose fields
        if (this.layerExposeFields && this.layerExposeFields.length > 0) {
            this.layerExposeAccumulationFields = JSON.parse(
                JSON.stringify(this.layerExposeFields)
            );
            this.layerExposeInitialDataLoaded = true;

            // Check if the notification already has saved layer expose fields
            this.processLayerExposeFields();
        } else {
            // No layer expose fields available yet, schedule check for later
            this.scheduleLayerExposeCheck();
        }

        this.fetchFormulas();
        this.initEarthquakeMagnitude();
        // Initialize component properties properly
        if (!this.selectedFormulas) {
            this.selectedFormulas = [];
        }
    }

    sortDatasetFields(): DatasetField[] {
        return this.dataset?.fields.sort((a, b) =>
            a.displayName > b.displayName ? 1 : -1
        );
    }

    private initNotifForm() {
        this.notifForm = this.formBuilder.group(
            new EventNotifControlsConfig(this.formBuilder, this.eventNotif)
        );
        this.onSaveFormWithoutFilter = false;
    }

    get DatasetFieldType() {
        return DatasetFieldType;
    }

    get DistanceUnit() {
        return DistanceUnit;
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        if (this.currencies) {
            return this.currencies.filter(
                (option) => option.toLowerCase().indexOf(filterValue) === 0
            );
        }
    }

    saveEventNotification() {
        // Reset validation states
        this.earthquakeMagnitudeInvalid = false;

        // Validate earthquake magnitude if earthquake overlay is selected
        if (this.isActiveEarthquakeSelected()) {
            // If magnitude field has been touched by the user, or it's a new event notification
            if (!this.eventNotif.id || this.magnitudeFieldTouched) {
                if (this.earthquakeMagnitude === undefined ||
                    this.earthquakeMagnitude === null ||
                    this.earthquakeMagnitude.toString() === '') {
                    this.earthquakeMagnitudeInvalid = true;
                    this.notifService.error("Earthquake magnitude is required");
                    return;
                }
            }
        }

        // check for float number to allow only two decimals
        this.selectedOverlayFilterItems.forEach((item) => {
            if (item.datasetField.baseType === DatasetFieldType.NUMBER) {
                /*if (item.statistics) {
                    this.assignStatisticalMinMaxValues(item);
                }*/
                item.minNumberValue = this.checkForFloatNumber(
                    item.minNumberValue
                );
                item.maxNumberValue = this.checkForFloatNumber(
                    item.maxNumberValue
                );
            }
        });
        this.accumulationFilterItems.forEach((item) => {
            if (item.datasetField.baseType === DatasetFieldType.NUMBER) {
                /*if (item.statistics) {
                    this.assignStatisticalMinMaxValues(item);
                }*/
                item.minNumberValue = this.checkForFloatNumber(
                    item.minNumberValue
                );
                item.maxNumberValue = this.checkForFloatNumber(
                    item.maxNumberValue
                );
            }
        });
        this.locationsFilterItems.forEach((item) => {
            if (item.datasetField.baseType === DatasetFieldType.NUMBER) {
                /*if (item.statistics) {
                    this.assignStatisticalMinMaxValues(item);
                }*/
                item.minNumberValue = this.checkForFloatNumber(
                    item.minNumberValue
                );
                item.maxNumberValue = this.checkForFloatNumber(
                    item.maxNumberValue
                );
            }
        });

        // Purpose: check min & max validation
        if (
            this.checkMinGreaterThanMax(this.selectedOverlayFilterItems) ||
            this.checkMinGreaterThanMax(this.accumulationFilterItems) ||
            this.checkMinGreaterThanMax(this.locationsFilterItems)
        ) {
            this.notifService.error(
                "Error. Min value cannot be greater than Max value."
            );
            return;
        }
        if (
            this.checkForMaxInputCharactersLength(
                this.selectedOverlayFilterItems
            ) ||
            this.checkForMaxInputCharactersLength(
                this.accumulationFilterItems
            ) ||
            this.checkForMaxInputCharactersLength(this.locationsFilterItems)
        ) {
            this.notifService.error("Error. Exceed the maximum for Max");
            return;
        }
        if (
            this.checkForMinInputCharactersLength(
                this.selectedOverlayFilterItems
            ) ||
            this.checkForMinInputCharactersLength(
                this.accumulationFilterItems
            ) ||
            this.checkForMinInputCharactersLength(this.locationsFilterItems)
        ) {
            this.notifService.error("Error. Exceed the maximum for Min");
            return;
        }
        if (
            this.checkForSearchValueInputCharactersLength(
                this.selectedOverlayFilterItems
            ) ||
            this.checkForSearchValueInputCharactersLength(
                this.accumulationFilterItems
            ) ||
            this.checkForSearchValueInputCharactersLength(
                this.locationsFilterItems
            )
        ) {
            this.notifService.error(
                "Error. Exceed the maximum accepted number of characters."
            );
            return;
        }

        // Check if Accumulation filter has at least one value selected
        const totalFieldsSelected = (this.accumulationFilterItems?.length || 0) +
                                   (this.layerExposeFilterItems?.length || 0) +
                                   (this.selectedFormulas?.length || 0);

        if (totalFieldsSelected === 0) {
            this.onSaveFormWithoutFilter = true;
            this.notifService.error(
                "Please select at least one field from Accumulation Filter, Layer Exposed Fields, or Formulas."
            );
            return;
        }

        // Check if Accumulation filter has more than 3 values selected
        if (totalFieldsSelected > 3) {
            this.onSaveFormWithoutFilter = true;
            this.notifService.error(
                "You cannot select more than 3 fields in total across Accumulation Filter, Layer Expose, and Formulas."
            );
            return;
        }

        // This validation is now redundant since we already checked for totalFieldsSelected above
        // Only validate location and overlay filters if no accumulation/layer expose/formula fields are selected
        /* if (
            !this.locationsFilterDisplayedValue &&
            !this.selectedOverlayFilterDisplayedValue &&
            totalFieldsSelected === 0
        ) {
            this.onSaveFormWithoutFilter = true;
            this.notifService.error(
                "Please select at least one Filter option."
            );
            return;
        } */

        this.onSaveFormWithoutFilter = false;

        // Extract form values
        const formValues = this.notifForm.value;

        // Create filter objects
        let overlayFilter;

        // Ensure earthquakeMagnitude is a number and has a valid value
        if (this.earthquakeMagnitude !== undefined && this.earthquakeMagnitude !== null) {
            this.earthquakeMagnitude = Number(this.earthquakeMagnitude);
        } else {
            // Set default value if undefined
            this.earthquakeMagnitude = 0;
        }

        // For earthquake overlay, always use the magnitude input field value
        if (this.selectedOverlay && this.selectedOverlay.id === "aeris_earthquake_circle") {
            overlayFilter = {
                datasetID: this.selectedOverlay.id,
                fields: [{
                    id: "earthquake_magnitude",
                    maxDateValue: null,
                    minDateValue: null,
                    minNumberValue: this.checkForFloatNumber(this.earthquakeMagnitude),
                    searchValue: null,
                    textValues: [],
                    distanceUnit: null
                }]
            };
        } else if (this.selectedOverlayFilterItems.length > 0) {
            // For other overlays, use selected filter items if available
            overlayFilter = this.datapointsFilterService.constructNewFilterObjectFromFilterBarItems(
                this.selectedOverlay.id,
                this.selectedOverlayFilterItems
            );
        } else if (this.selectedOverlay) {
            // Create a default filter structure with empty fields array
            overlayFilter = {
                datasetID: this.selectedOverlay.id,
                fields: []
            };

            // Add default field based on overlay type
            if (this.selectedOverlay.id === "aeris_storm_beautified") {
                overlayFilter.fields.push({
                    id: "storm_name",
                    maxDateValue: null,
                    minDateValue: null,
                    minNumberValue: null,
                    searchValue: null,
                    textValues: [],
                    distanceUnit: null
                });
            } else if (this.selectedOverlay.id === "aeris_hail_storm") {
                overlayFilter.fields.push({
                    id: "radius",
                    minNumberValue: formValues.radius || null,
                    maxNumberValue: null,
                    maxDateValue: null,
                    minDateValue: null,
                    searchValue: null,
                    textValues: [],
                    distanceUnit: this.distanceUnit
                });
            } else if (this.selectedOverlay.id === "aeris_tornado_outlooks") {
                overlayFilter.fields.push({
                    id: "outlook_type",
                    minNumberValue: null,
                    maxNumberValue: null
                });
            }
        }

        // Ensure each field in overlayFilter has the required 'id' property
        if (overlayFilter && overlayFilter.fields) {
            // Set the datasetID to match the overlayId
            overlayFilter.datasetID = formValues.overlayId;

            overlayFilter.fields.forEach((field) => {
                // Make sure each field has an 'id' property
                if (!field.id && this.selectedOverlay) {
                    // For earthquake magnitude filter
                    if (
                        this.selectedOverlay.id === "aeris_earthquake_circle" &&
                        field.minNumberValue !== null &&
                        field.minNumberValue !== undefined
                    ) {
                        field.id = "magnitude"; // Set to appropriate field ID for earthquake magnitude
                    }
                    if (
                        this.selectedOverlay.id === "aeris_storm_beautified" &&
                        field.maxNumberValue !== null &&
                        field.maxNumberValue !== undefined
                    ) {
                        field.id = "storm_name"; // Set to appropriate field ID for earthquake magnitude
                    }
                    if (
                        this.selectedOverlay.id === "aeris_hail_storm" &&
                        field.minNumberValue !== null &&
                        field.minNumberValue !== undefined
                    ) {
                        field.id = "radius"; // Set to appropriate field ID for hail storm radius
                    }
                    if (
                        this.selectedOverlay.id === "aeris_tornado_outlooks" &&
                        field.maxNumberValue !== null &&
                        field.maxNumberValue !== undefined
                    ) {
                        field.id = "outlook_type"; // Set to appropriate field ID for earthquake magnitude
                    }
                    // Add other hardcoded overlay field IDs as needed
                }
            });
        }

        const locationsFilter =
            this.datapointsFilterService.constructNewFilterObjectFromFilterBarItems(
                this.dataset.id,
                this.locationsFilterItems
            );

        const accumulationFilter =
            this.datapointsFilterService.constructNewFilterObjectFromFilterBarItems(
                this.dataset.id,
                this.accumulationFilterItems
            );

        // Construct a clean notification object matching API expectations
        const cleanEventNotif: EventNotificationSettings = {
            id: this.eventNotif.id, // Preserve existing ID for updates
            memberId: formValues.memberId,
            notificationName: formValues.notificationName,
            overlayId: formValues.overlayId,
            datasetId: formValues.datasetId,
            radius: formValues.radius,
            distanceUnit: this.distanceUnit,
            locationBreakdownFieldId: formValues.locationBreakdownFieldId || "",
            currency: formValues.currency || "",
            personalizedSubject: formValues.personalizedSubject || "",
            personalizedMessage: formValues.personalizedMessage || "",
            ccEmails: this.alertsEmails,
            sendOneAlertDaily: formValues.sendOneAlertDaily || false,
            showDetailedLocationList: formValues.showDetailedLocationList || false,
            overlayFilter: overlayFilter,
            locationFilter: locationsFilter,
            locationsCumulatedFilter: accumulationFilter,
            layerExposeCumulatedFilter: [],
            formulas:  this.selectedFormulas.length > 0
            ? this.selectedFormulas.map((formula) => formula.name)
            : [],
        };

        // Add groups if selected
        if (this.selectedGroupIds && this.selectedGroupIds.length > 0) {
            const validGroups = this.selectedGroupIds
                .map((id) => {
                    const group = this.allGroups.find((g) => g.id === id);
                    if (!group) {
                        return null;
                    }
                    return {
                        id: group.id,
                        datasetID: group.datasetID || this.dataset.id,
                        accountID: group.accountID,
                        name: group.name,
                        parentId: group.parentId || group.parentID || 0,
                        parentID: group.parentID || group.parentId || 0, // Add parentID (uppercase) property
                        type:
                            typeof group.type === "string"
                                ? parseInt(group.type, 10) || 0
                                : group.type || 0,
                        isDefault: group.isDefault || false,
                        createdOn: group.createdOn || Date.now(), // Add createdOn with fallback
                        updatedOn: group.updatedOn || Date.now(), // Add updatedOn with fallback
                    };
                })
                .filter(Boolean);

            if (validGroups.length > 0) {
                cleanEventNotif.groups = validGroups;
                this.groups = validGroups;
            }
        }

        // Add layer expose fields if any
        if (
            this.layerExposeFilterItems &&
            this.layerExposeFilterItems.length > 0
        ) {
            // Store only essential properties for each layer expose field to ensure consistency
            cleanEventNotif.layerExposeCumulatedFilter = this.layerExposeFilterItems.map(field => ({
                id: field.id,
                accountId: field.accountId,
                name: field.name,
                baseValue: field.baseValue || null,
                layerValue: field.layerValue || null,
                attachmentPoint: field.attachmentPoint || null,
                isApplied: field.isApplied || false,
                participation: field.participation || 0
            }));
        }

        // Replace contaminated object with clean one
        this.eventNotif = cleanEventNotif;

        if (!this.eventNotif.id) {
            this.eventNotifService
                .createNotification(this.eventNotif)
                .subscribe(
                    (notif) => {
                        this.eventNotif = notif;
                        this.initNotifForm();
                        this.notifService.success(
                            "Notification trigger was successfully saved"
                        );
                    },
                    (error) =>
                        this.notifService.error(
                            "Something went wrong...Please recheck the fields"
                        )
                );
        } else {
            this.eventNotifService
                .updateNotification(this.eventNotif)
                .subscribe(
                    (notif) => {
                        this.eventNotif = notif;
                        this.initNotifForm();
                        this.notifService.success(
                            "Notification trigger was successfully updated"
                        );
                    },
                    (error) =>
                        this.notifService.error(
                            "Something went wrong...Please recheck the fields"
                        )
                );
        }
    }

    deleteEventNotification() {
        const dialogRef = this.dialog.open(DialogComponent, {
            data: new DialogModel(
                "Confirm Action",
                `Are you sure you want to delete alert?`
            ),
        });
        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    if (this.eventNotif.id) {
                        this.eventNotifService
                            .deleteNotification([this.eventNotif.id])
                            .subscribe();
                    }

                    this.deleteEventNotif.emit(this.eventNotif);
                    this.notifService.success(
                        "Notification was deleted successfully."
                    );
                }
            });
    }

    populateFilterBarItem(
        filterBarItem: FilterBarItem,
        filterField: DatapointFilterField
    ): FilterBarItem {
        filterBarItem.maxNumberValue =
            filterField.maxNumberValue == MAX_NUMBER_VALUE
                ? undefined
                : filterField.maxNumberValue;
        filterBarItem.minNumberValue =
            filterField.minNumberValue == MAX_NUMBER_VALUE
                ? undefined
                : filterField.minNumberValue;
        filterBarItem.minDateValue =
            filterField.minDateValue > 0 ? filterField.minDateValue : null;
        filterBarItem.maxDateValue =
            filterField.maxDateValue > 0 ? filterField.maxDateValue : null;
        filterBarItem.searchValue = filterField.searchValue;

        return filterBarItem;
    }

    // --------------------------- Overlay ------------------------------
    isActiveEarthquakeSelected(): boolean {
        return (
            this.selectedOverlay &&
            this.selectedOverlay.id === "aeris_earthquake_circle"
        );
    }

    isActiveTropicalStormSelected(): boolean {
        return (
            this.selectedOverlay &&
            this.selectedOverlay.id === "aeris_storm_beautified"
        );
    }

    isActiveHailStormSelected(): boolean {
        return (
            this.selectedOverlay &&
            this.selectedOverlay.id === "aeris_hail_storm"
        );
    }

    onChangeFilterItemsForOverlay(selected: boolean, field: DatasetField) {
        field.selected = !field.selected;
        if (field.selected) {
            this.constructFilterItemForOverlay(field, []);
        } else {
            let start = this.selectedOverlayFilterItems.findIndex(
                (item) => item.id === field.id
            );
            this.selectedOverlayFilterItems.splice(start, 1);
        }

        this.selectedOverlayFilterDisplayedValue =
            this.constructFilterDisplayedValue(this.selectedOverlayFilterItems);
        this.checkForSelectedFilters(
            this.selectedOverlayFilterItems,
            this.locationsFilterItems,
            this.accumulationFilterItems
        );
    }

    checkForSelectedFilters(
        overlaysFilter: FilterBarItem[],
        locationsFilter: FilterBarItem[],
        accumulationFilter: FilterBarItem[]
    ) {
        // Calculate total selected fields across all filter types
        const totalFieldsSelected = (accumulationFilter?.length || 0) +
                                   (this.layerExposeFilterItems?.length || 0) +
                                   (this.selectedFormulas?.length || 0);

        if (
            overlaysFilter.length > 0 ||
            locationsFilter.length > 0 ||
            totalFieldsSelected > 0
        ) {
            this.onSaveFormWithoutFilter = false;
        } else {
            this.onSaveFormWithoutFilter = true;
            this.notifService.error(
                "Please select at least one field from Accumulation Filter, Layer Exposed Fields, or Formulas."
            );
        }
    }

    private constructFilterItemForOverlay(
        field: DatasetField,
        selectedStatisticValues: string[]
    ): FilterBarItem {
        let filterBarItem = {
            id: field.id,
            dataset: this.selectedOverlay,
            datasetField: field,
        };
        if (!field.isHighCardinality) {
            this.datapointsFilterService.fetchFilterBarItemStatistics(
                filterBarItem,
                this.selectedOverlay,
                field,
                [],
                selectedStatisticValues
            );
        }
        this.selectedOverlayFilterItems.push(filterBarItem);

        return filterBarItem;
    }

    // --------------------------- End Overlay ------------------------------

    // --------------------------- Locations ------------------------------
    onChangeFilterItemForLocations(selected: boolean, field: DatasetField) {
        field.selected = !field.selected;
        if (field.selected) {
            this.constructFilterItemForLocations(field, []);
        } else {
            let start = this.locationsFilterItems.findIndex(
                (item) => item.id === field.id
            );
            this.locationsFilterItems.splice(start, 1);
        }

        this.locationsFilterDisplayedValue = this.constructFilterDisplayedValue(
            this.locationsFilterItems
        );
        this.checkForSelectedFilters(
            this.selectedOverlayFilterItems,
            this.locationsFilterItems,
            this.accumulationFilterItems
        );
    }

    private constructFilterItemForLocations(
        field: DatasetField,
        selectedStatisticValues: string[]
    ): FilterBarItem {
        let filterBarItem = {
            id: field.id,
            dataset: this.dataset,
            datasetField: field,
        };
        this.locationsFilterItems.push(filterBarItem);
        if (!field.isHighCardinality) {
            this.datapointsFilterService.fetchFilterBarItemStatistics(
                filterBarItem,
                this.dataset,
                field,
                this.groupsIds,
                selectedStatisticValues
            );
        }
        return filterBarItem;
    }

    // --------------------------- End Locations ------------------------------

    // --------------------------- Accumulation ------------------------------
    onChangeFilterItemForAccumulation(selected: boolean, field: DatasetField) {
        // If already selected, allow deselection
        if (field.selected) {
            field.selected = false;
            let start = this.accumulationFilterItems.findIndex(
                (item) => item.id === field.id
            );
            this.accumulationFilterItems.splice(start, 1);
        }
        // If not selected, check if we can add another field
        else {
            // Count total fields currently selected
            const totalFields =
                this.accumulationFilterItems.length +
                this.layerExposeFilterItems.length +
                this.selectedFormulas.length;

            // If already at limit, show error and don't select
            if (totalFields >= 3) {
                this.notifService.error(
                    "You cannot select more than 3 fields in total across Accumulation Filter, Layer Expose, and Formulas."
                );
                return;
            }

            // Otherwise select the field
            field.selected = true;
            this.constructFilterItemForAccumulation(field, []);
        }

        // Update displayed values and check filters
        this.checkForSelectedFilters(
            this.selectedOverlayFilterItems,
            this.locationsFilterItems,
            this.accumulationFilterItems
        );

        this.accumulationFilterDisplayedValue =
            this.constructFilterDisplayedValue(this.accumulationFilterItems);

        // Refresh formula display to properly update all selected fields
        this.refreshFormulaDisplay();
    }

    onAccumulationFilterChange(event: any) {
        if (!event || !event.value) return;

        // Find the field that matches the selected value
        const selectedField = this.eligibleAccumulationFields.find(
            (field) =>
                field.name === event.value || field.displayName === event.value
        );

        if (selectedField) {
            // Mark as selected if not already
            if (!selectedField.selected) {
                selectedField.selected = true;
                this.constructFilterItemForAccumulation(selectedField, []);
                this.checkForSelectedFilters(
                    this.selectedOverlayFilterItems,
                    this.locationsFilterItems,
                    this.accumulationFilterItems
                );
                // Force change detection to update the UI
                this.changeDetector.detectChanges();
            }
        }
    }

    onAccumulationDropdownOpened() {
        // This ensures all sections (accumulation fields, layer expose fields, formulas)
        // are prepared and available when the dropdown is opened
        this.filterFieldSearchString = "";

        // Force change detection to ensure all elements are properly displayed
        this.changeDetector.detectChanges();
    }

    private constructFilterItemForAccumulation(
        field: DatasetField,
        selectedStatisticValues: string[]
    ): FilterBarItem {
        let filterBarItem = {
            id: field.id,
            dataset: this.dataset,
            datasetField: field,
        };
        this.accumulationFilterItems.push(filterBarItem);
        if (!field.isHighCardinality) {
            this.datapointsFilterService.fetchFilterBarItemStatistics(
                filterBarItem,
                this.dataset,
                field,
                this.groupsIds,
                selectedStatisticValues
            );
        }
        // Force change detection to update the UI with the selected item
        this.changeDetector.detectChanges();
        return filterBarItem;
    }
    onChangeLayerExposeField(
        selected: boolean,
        field: LayerExposeFieldWithSelection
    ) {
        field.selected = !field.selected;

        if (field.selected) {
            this.addLayerExposeFilterItem(field);
        } else {
            const index = this.layerExposeFilterItems.findIndex(
                (item) => item.id === field.id
            );
            if (index !== -1) {
                this.layerExposeFilterItems.splice(index, 1);
            }
        }

        // Use refreshFormulaDisplay to ensure consistent behavior
        this.refreshFormulaDisplay();

        // Check for selected filters to update the error state
        this.checkForSelectedFilters(
            this.selectedOverlayFilterItems,
            this.locationsFilterItems,
            this.accumulationFilterItems
        );


        // Force change detection to update the UI
        this.changeDetector.detectChanges();
    }
    handleCheckboxChange(event: any, item: any, type: string, selectRef: MatSelect) {
        const selectedCount = this.getTotalSelectedCount(); // Get the total count of selected items

        if (selectedCount <= 3 || item.selected) { // Allow selection if less than 3, or toggle the selected item
            switch (type) {
                case 'accumulation':
                    this.onChangeFilterItemForAccumulation(item.selected, item); // Handle accumulation fields
                    break;
                case 'layerExpose':
                    this.onChangeLayerExposeField(event, item); // Handle layer expose fields
                    break;
                case 'formula':
                    this.onFormulaSelectionChange(event, item); // Handle formula selection
                    break;
            }
        } else {
            this.showErrorMessage('Cannot select more than 3 fields total');
            event.source.checked = false; // Uncheck the item that was just clicked
            return;
        }

        // If 3 selections are made, close the dropdown
        if (this.getTotalSelectedCount() === 3) {
            selectRef.close();  // Close the mat-select dropdown manually
        }
    }


    getTotalSelectedCount(): number {
        return (this.accumulationFilterItems.length || 0) +
               (this.layerExposeFilterItems.length || 0) +
               (this.selectedFormulas.length || 0);
    }



    private addLayerExposeFilterItem(
        field: LayerExposeFieldWithSelection
    ): void {
        const filterItem: LayerExposeFieldWithSelection = {
            id: field.id,
            accountId: field.accountId,
            name: field.name,
            baseValue: field.baseValue,
            layerValue: field.layerValue,
            attachmentPoint: field.attachmentPoint,
            isApplied: field.isApplied,
            participation: field.participation,
            selected: true,
        };

        this.layerExposeFilterItems.push(filterItem);
    }

    addFormula() {
        if (this.formulaName && this.selectedFormulaType) {
            // Create a proper WorkspaceItem object for formula
            const formula: WorkspaceItem = {
                id: -1, // This will be assigned by backend
                accountId: this.eventNotif.memberId, // Using memberId as accountId
                datasetId: this.eventNotif.datasetId,
                name: this.formulaName,
                type: WorkspaceItemType.FORMULA,
                access: WorkspaceItemAccess.MEMBER, // Assuming private access
                data: JSON.stringify({
                    type: this.selectedFormulaType,
                    // Add any other formula-specific data here
                }),
            };

            this.formulas.push(formula);

            // Reset form
            this.formulaName = "";
            this.selectedFormulaType = "";
        } else {
            this.notifService.error(
                "Please provide both formula name and type"
            );
        }
    }

    /**
     * Check if a formula is selected
     */
    isFormulaSelected(formula: WorkspaceItem): boolean {
        return this.selectedFormulas.some(f => f.id === formula.id);
    }

    /**
     * Handle formula checkbox selection
     */
    onFormulaSelectionChange(event: any, formula: WorkspaceItem): void {

        // If trying to check the checkbox and already at limit, prevent selection
        if (event.checked && !this.isFormulaSelected(formula) && this.isMaxFieldsSelected()) {
            event.source.checked = false; // Reset checkbox state
            this.notifService.error(
                "You cannot select more than 3 fields in total across Accumulation Filter, Layer Expose, and Formulas."
            );
            return;
        }

        if (event.checked) {
            // Add to selected formulas if not already there
            if (!this.isFormulaSelected(formula)) {
                this.selectedFormulas = [...this.selectedFormulas, formula]; // Create new array reference
            }
        } else {
            // Remove from selected formulas
            this.selectedFormulas = this.selectedFormulas.filter(f => f.id !== formula.id);
        }

        // Use refreshFormulaDisplay to ensure consistent behavior
        this.refreshFormulaDisplay();

        // Check for selected filters to update the error state
        this.checkForSelectedFilters(
            this.selectedOverlayFilterItems,
            this.locationsFilterItems,
            this.accumulationFilterItems
        );
    }

    /**
     * Extract and return the formula expression from the formula data
     */
    getFormulaType(formula: WorkspaceItem): string {
        try {
            if (formula.data) {
                const data = JSON.parse(formula.data);
                return data.formula || data.type || "Unknown";
            }
            return "Unknown";
        } catch (e) {
            console.error("Error parsing formula data", e);
            return "Unknown";
        }
    }

    /**
     * Remove a formula from the list
     */
    removeFormula(index: number): void {
        if (index >= 0 && index < this.formulas.length) {
            this.formulas.splice(index, 1);
        }
    }

    // --------------------------- End Accumulation ------------------------------

    private constructFilterDisplayedValue(
        filterBarItems: FilterBarItem[]
    ): string {
        let displayValue = "";
        filterBarItems.forEach((filterItem) => {
            displayValue += filterItem.datasetField.name + ", ";
        });
        return displayValue.slice(0, displayValue.length - 2); // remove last comma
    }

    onSelectedOverlayChange(event: any) {
        if (event.isUserInput) {
            this.selectedOverlay = this.eligibleOverlays.find(
                (dataset) => dataset.id === event.source.value
            );
            this.selectedOverlayFilterItems = [];
            this.selectedOverlayFilterDisplayedValue = "";
        }
        // reset all overlays fields that can be checked
        this.eligibleOverlays.forEach((eligibleOverlay) => {
            if (
                this.selectedOverlay &&
                eligibleOverlay.id !== this.selectedOverlay.id
            ) {
                eligibleOverlay.fields.forEach((field) => {
                    field.selected = false;
                });
            }
        });
    }

    constructFilterItemDisplayValues(filterItem: FilterBarItem) {
        this.filterStatisticValuesString = "";
        filterItem.displayedSearchValue =
            this.datapointsFilterService.constructFilterDisplayValue(
                filterItem
            );
    }

    search(value: string) {
        let filter = value.toLowerCase();
        return this.currencies.filter((option) =>
            option.toLowerCase().startsWith(filter)
        );
    }

    assignStatisticalMinMaxValues(item: FilterBarItem) {
        if (item.minNumberValue === undefined || item.minNumberValue === null) {
            item.minNumberValue = item.statistics.minValue;
        }
        if (item.maxNumberValue === undefined || item.maxNumberValue === null) {
            item.maxNumberValue = item.statistics.maxValue;
        }
    }

    private fetchFormulas() {
        this.workspaceItemService
            .getAllWorkspaceItemsForUser(
                this.dataset.id,
                WorkspaceItemType.FORMULA
            )
            .subscribe(
                (items) => {
                    this.formulas = items.map(item => ({
                        ...item,
                        name: decodeHtmlText(item.name)
                    }));

                    // If eventNotif has formulas, populate selectedFormulas array
                    if (this.eventNotif && this.eventNotif.formulas && Array.isArray(this.eventNotif.formulas) && this.eventNotif.formulas.length > 0) {
                        // Find workspace items that match the formula names in eventNotif.formulas
                        this.selectedFormulas = this.formulas.filter(formula =>
                            this.eventNotif.formulas.includes(formula.name)
                        );

                        // After setting the formulas, update the display
                        this.refreshFormulaDisplay();
                    } else {
                        // Make sure selectedFormulas is an empty array when no formulas are selected
                        this.selectedFormulas = [];
                    }

                    // Force change detection to update the UI after formulas are loaded
                    this.changeDetector.detectChanges();
                },
                (error) => {
                    console.error("Error fetching formulas:", error);
                }
            );
    }

    private fetchGroupsForMember() {
        if (
            !this.eventNotif.datasetId ||
            !this.groups ||
            this.groups.length === 0
        ) {
            return;
        }

        this.allGroups = this.groups;

        // For new notifications, deselect all groups by default
        if (!this.eventNotif.groups || this.eventNotif.groups.length === 0) {
            this.eventNotif.groups = [];
            this.selectedGroupIds = [];
        } else {
            // For existing notification, use its selections
            this.selectedGroupIds = this.eventNotif.groups.map(
                (group) => group.id
            );
        }

        // Update form control value if it exists
        if (this.notifForm && this.notifForm.get("groups")) {
            this.notifForm.get("groups").setValue(this.selectedGroupIds);
        }
    }

    onGroupSelectionChange(event: any) {
        this.selectedGroupIds = event.value;

        // Validate that at least one default group is selected
        const hasDefaultGroup = this.selectedGroupIds.some((groupId) =>
            this.allGroups.find((g) => g.id === groupId && g.isDefault)
        );

        if (!hasDefaultGroup) {
            this.notifService.error(
                "At least one default group must be selected"
            );
        }
    }

    /*
    Purpose: check min & max validation
    Date: 8 April 2022
    */
    checkMinGreaterThanMax(list: FilterBarItem[]) {
        let failCounter = 0;
        if (list !== undefined && list.length > 0) {
            for (let item of list) {
                if (item.datasetField.baseType === DatasetFieldType.NUMBER) {
                    if (item.minNumberValue !== undefined) {
                        // If item.minNumberValue is defined, check if item.maxNumberValue is also defined and greater than item.minNumberValue
                        if (
                            item.maxNumberValue === undefined ||
                            item.maxNumberValue === null ||
                            item.minNumberValue < item.maxNumberValue
                        ) {
                            // Validation failed - item.maxNumberValue should be greater than item.minNumberValue
                            return false;
                        } else {
                            failCounter++;
                        }
                    }
                    //    if ((item.minNumberValue !== undefined || item.maxNumberValue !== undefined) && (item.maxNumberValue === undefined || item.minNumberValue > item.maxNumberValue)) {
                    //        return true;
                    //    }
                }
            }
        }
        return failCounter > 0;
    }

    checkForMaxInputCharactersLength(list: FilterBarItem[]) {
        if (list !== undefined && list.length > 0) {
            for (let item of list) {
                if (item.datasetField.baseType === DatasetFieldType.NUMBER) {
                    if (
                        item.maxNumberValue !== undefined &&
                        item.maxNumberValue !== null
                    ) {
                        let maxStringValue;
                        maxStringValue = item.maxNumberValue.toString(10);
                        if (maxStringValue.length > LIMIT_NUMBER_LENGTH) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }

    checkForMinInputCharactersLength(list: FilterBarItem[]) {
        return false;
    }

    checkForSearchValueInputCharactersLength(list: FilterBarItem[]) {
        if (list !== undefined && list.length > 0) {
            for (let item of list) {
                if (item.datasetField.baseType === DatasetFieldType.TEXT) {
                    if (
                        item.searchValue !== undefined &&
                        item.searchValue !== null
                    ) {
                        if (item.searchValue.length > LIMIT_STRING_LENGTH) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }
    }

    checkForFloatNumber(value: number) {
        if (value && value % 1 !== 0) {
            let fixedValue = value.toFixed(2);
            return Number(fixedValue);
        } else {
            return value;
        }
    }

    emptySearchString() {
        this.filterFieldSearchString = "";
    }

    addEmail(event: MatChipInputEvent): void {
        if (!this.emailsForm.invalid) {
            const value = (event.value || "").trim();
            if (value) {
                const emailExists = this.alertsEmails.some(
                    (e) => e.email === value
                );

                if (this.alertsEmails.length >= MAX_EMAILS) {
                    this.notifService.error(
                        `You can only add up to ${MAX_EMAILS} emails.`
                    );
                } else if (!emailExists) {
                    // Check if the email is external (not in accountMemberEmails)
                    const isInternalEmail = this.accountMemberEmails.includes(value);

                    // Clear input immediately to prevent duplicate events
                    event.chipInput!.clear();

                    if (!isInternalEmail && !this.isDialogOpen) {
                        // Store email temporarily to add after confirmation
                        const emailToAdd = value;

                        // Show warning for external email
                        this.isDialogOpen = true;
                        const dialogRef = this.dialog.open(DialogComponent, {
                            data: new DialogModel(
                                "External Email Warning",
                                "You are adding an external email address. Please be aware that this may share sensitive information outside your organization and provide access to restricted data. Do you want to continue?"
                            ),
                        });

                        dialogRef
                            .afterClosed()
                            .pipe(take(1))
                            .subscribe((dialogResult) => {
                                this.isDialogOpen = false;
                                if (dialogResult) {
                                    // User confirmed, add the email
                                    this.alertsEmails.push({
                                        email: emailToAdd,
                                        subscribed: true,
                                    });
                                }
                            });
                    } else if (!this.isDialogOpen) {
                        // Internal email, add directly without warning
                        this.alertsEmails.push({
                            email: value,
                            subscribed: true,
                        });
                    }
                }
            }
        }
    }
    // removeEmail(fruit: string): void {
    //     const index = this.alertsEmails.indexOf(fruit);

    //     if (index >= 0) {
    //         this.alertsEmails.splice(index, 1);
    //     }
    // }
    removeEmail(email: string): void {
        this.alertsEmails = this.alertsEmails.filter((e) => e.email !== email);
    }

    toggleSubscription(email: string): void {
        const target = this.alertsEmails.find((e) => e.email === email);
        if (target) {
            target.subscribed = !target.subscribed;
        }
    }
    private refreshFormulaDisplay(): void {
        // Force update the selected formulas array with a new reference to trigger change detection
        this.selectedFormulas = [...this.selectedFormulas];

        // Update the eventNotif.formulas array
        if (this.eventNotif) {
            this.eventNotif.formulas = this.selectedFormulas.map(f => f.name);
        }

        // Update the layerExposeFilterDisplayedValue if there are layer expose items
        if (this.layerExposeFilterItems.length > 0) {
            this.layerExposeFilterDisplayedValue = this.constructLayerExposeFilterDisplayValue();
        }

        // Update accumulation filter display value with all selected fields
        this.updateAccumulationFilterDisplayValue();

        // Force change detection with a delay to ensure DOM updates
        setTimeout(() => {
            this.changeDetector.detectChanges();
        }, 0);
    }

    showSelectedFields(): boolean {
        // Return true if any type of field is selected, regardless of combination
        return (this.accumulationFilterItems && this.accumulationFilterItems.length > 0) ||
               (this.layerExposeFilterItems && this.layerExposeFilterItems.length > 0) ||
               (this.selectedFormulas && this.selectedFormulas.length > 0);
    }

    private constructLayerExposeFilterDisplayValue(): string {
        return this.layerExposeFilterItems.map(item => decodeHtmlText(item.name)).join(', ');
    }

    private updateAccumulationFilterDisplayValue(): void {
        let displayValue = '';

        // Get regular accumulation field names
        const accumulationNames = this.accumulationFilterItems.map(item =>
            decodeHtmlText(item.datasetField.displayName ?? item.datasetField.name)
        );

        // Get layer expose field names
        const layerExposeNames = this.layerExposeFilterItems.map(item =>
            decodeHtmlText(item.name)
        );

        // Get formula names
        const formulaNames = this.selectedFormulas.map(formula =>
            decodeHtmlText(formula.name)
        );

        // Combine all names
        const allNames = [...accumulationNames, ...layerExposeNames, ...formulaNames];

        // Create the display value from all selected fields
        if (allNames.length > 0) {
            // Always show the field names regardless of count
            displayValue = allNames.join(', ');
        }

        this.accumulationFilterDisplayedValue = displayValue;

        // Also update layerExposeFilterDisplayedValue if there are any layer expose items
        if (this.layerExposeFilterItems.length > 0) {
            this.layerExposeFilterDisplayedValue = layerExposeNames.join(', ');
        }

        // Force change detection with timeout to ensure DOM updates
        setTimeout(() => {
            this.changeDetector.detectChanges();
        });
    }

    private initEarthquakeMagnitude(): void {
        if (this.eventNotif.overlayFilter && this.eventNotif.overlayFilter.fields) {
            // First try with "magnitude" field ID
            let magnitudeField = this.eventNotif.overlayFilter.fields.find(
                (field) => field.id === "magnitude"
            );

            // If not found, try with "earthquake_magnitude" field ID used in saving
            if (!magnitudeField) {
                magnitudeField = this.eventNotif.overlayFilter.fields.find(
                    (field) => field.id === "earthquake_magnitude"
                );
            }

            // Set the magnitude value if any field was found with a valid value
            if (magnitudeField && magnitudeField.minNumberValue !== undefined && magnitudeField.minNumberValue !== null) {
                this.earthquakeMagnitude = magnitudeField.minNumberValue;
            }
        }
    }

    // New helper method to get total fields count
    public getTotalFieldsCount(): number {
        let count = 0;

        // Count accumulation filter items
        if (this.accumulationFilterItems) {
            count += this.accumulationFilterItems.length;
        }

        // Count layer expose filter items
        if (this.layerExposeFilterItems) {
            count += this.layerExposeFilterItems.length;
        }

        // Count selected formulas
        if (this.selectedFormulas) {
            count += this.selectedFormulas.length;
        }

        return count;
    }

    // Method to check if maximum fields are selected
    public isMaxFieldsSelected(): boolean {
        // Simple count calculation
        const total = (this.accumulationFilterItems?.length || 0) +
                      (this.layerExposeFilterItems?.length || 0) +
                      (this.selectedFormulas?.length || 0);
        return total >= 3;
    }

    // Helper method to determine if a checkbox should be disabled
    public shouldDisableCheckbox(isSelected: boolean): boolean {
        // If already selected, don't disable
        if (isSelected) {
            return false;
        }

        // Count all selected fields
        const totalSelected =
            (this.accumulationFilterItems?.length || 0) +
            (this.layerExposeFilterItems?.length || 0) +
            (this.selectedFormulas?.length || 0);

        // Disable if already at maximum
        return totalSelected >= 3;
    }

    // Public method to show error messages that can be called from the HTML template
    public showErrorMessage(message: string): void {
        this.notifService.error(message);
    }

    onMagnitudeChange() {
        this.magnitudeFieldTouched = true;
        // Reset validation when user is typing
        this.earthquakeMagnitudeInvalid = false;
    }

    /**
     * Process layer expose fields from saved notification
     * This method can be called multiple times if fields aren't available initially
     */
    private processLayerExposeFields(): void {
        // Only process if we have saved layer expose fields
        if (
            this.eventNotif.layerExposeCumulatedFilter &&
            this.eventNotif.layerExposeCumulatedFilter.length > 0
        ) {
            // Clear any previously mapped items to avoid duplicates on retries
            if (this.layerExposeFilterItems.length > 0) {
                console.log('Clearing previous layer expose items before remapping');
                this.layerExposeFilterItems = [];
            }

            // First try matching by ID
            this.eventNotif.layerExposeCumulatedFilter.forEach((savedField) => {
                // Try to find matching field by ID first
                let field = this.layerExposeAccumulationFields.find(f => f.id === savedField.id);

                // If not found by ID, try matching by name
                if (!field && savedField.name) {
                    field = this.layerExposeAccumulationFields.find(f => f.name === savedField.name);
                }

                if (field) {
                    field.selected = true;
                    this.addLayerExposeFilterItem(field);
                } else {
                    // If field isn't found in current layer expose fields, add it directly from saved data
                    const filterItem = { ...savedField, selected: true };
                    this.layerExposeFilterItems.push(filterItem);

                    // Also add to accumulation fields so it appears in dropdown
                    if (!this.layerExposeAccumulationFields.some(f => f.id === savedField.id || f.name === savedField.name)) {
                        this.layerExposeAccumulationFields.push({ ...savedField, selected: true });
                    }
                }
            });

            this.layerExposeFilterDisplayedValue = this.constructLayerExposeFilterDisplayValue();
            this.updateAccumulationFilterDisplayValue();

            // Force change detection and log results
            this.changeDetector.detectChanges();
        }
    }

    /**
     * Schedule a check to see if layer expose fields have been loaded
     * This helps handle race conditions where fields load after component initialization
     */
    private scheduleLayerExposeCheck(): void {
        if (this.layerExposeCheckAttempts >= this.maxLayerExposeCheckAttempts) {
            return;
        }

        this.layerExposeCheckAttempts++;
        // Use setTimeout to check if fields are available after a delay
        setTimeout(() => {
            // Check if layerExposeFields have been loaded since initialization
            if (this.layerExposeFields && this.layerExposeFields.length > 0) {
                // Fields are available now but weren't before
                if (!this.layerExposeInitialDataLoaded) {
                    this.layerExposeAccumulationFields = JSON.parse(JSON.stringify(this.layerExposeFields));
                    this.layerExposeInitialDataLoaded = true;
                }

                // Process the saved layer expose fields
                this.processLayerExposeFields();
            } else {
                // Still no fields available, try again
                this.scheduleLayerExposeCheck();
            }
        }, 1000); // 1 second delay between checks
    }
}

export class EventNotifControlsConfig {
    id = this.eventNotif.id;
    memberId = [this.eventNotif.memberId, [Validators.required]];
    notificationName = [
        this.eventNotif.notificationName,
        [Validators.required, Validators.maxLength(50)],
    ];
    overlayId = [this.eventNotif.overlayId, [Validators.required]];
    datasetId = [this.eventNotif.datasetId, [Validators.required]];
    radius = [
        this.eventNotif.radius,
        [
            Validators.required,
            Validators.max(this.MAXIMUM_RADIUS),
            this.allowOnlyPositiveNumbers.bind(this),
        ],
    ];
    distanceUnit = [this.eventNotif.distanceUnit, [Validators.required]];
    locationBreakdownFieldId = this.eventNotif.locationBreakdownFieldId;
    currency = this.eventNotif.currency;
    ccEmails = [this.eventNotif.ccEmails];
    personalizedSubject = this.eventNotif.personalizedSubject;
    personalizedMessage = this.eventNotif.personalizedMessage;
    sendOneAlertDaily = [this.eventNotif.sendOneAlertDaily || false];
    showDetailedLocationList = [this.eventNotif.showDetailedLocationList || false];
    groups = [
        this.eventNotif.groups
            ? this.eventNotif.groups.map((group) => group.id)
            : [],
        [Validators.required],
    ];
    constructor(
        private readonly formBuilder: UntypedFormBuilder,
        private readonly eventNotif: EventNotificationSettings,
        private MAXIMUM_RADIUS = 10000
    ) {}
    // custom validator
    allowOnlyPositiveNumbers(control: UntypedFormControl): {
        [key: string]: boolean;
    } {
        if (control.value !== null) {
            // only positive integers and decimals with 2 decimals only
            let regExp = new RegExp(
                "^[+]?([0-9]+(?:[\\.][0-9]{1,2})?|\\.[0-9]+)$"
            );
            if (!control.value.toString().match(regExp)) {
                return { allowPositiveOnly: true };
            }
        }
        return null;
    }
}
